var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ant-layout-sider-children"},[_c('div',{staticClass:"alain-pro__sider-logo"},[(_vm.loading)?_c('router-link',{staticClass:"alain-pro__header-logo-link",attrs:{"to":"/"}},[_c('img',{staticClass:"tenant-logo",attrs:{"src":_vm.path + _vm.logoPic}})]):_vm._e()],1),_c('yoyo-sidebar-nav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }